module.exports = __webpack_public_path__ + "static/img/liuc2x.add3ee06.png";